/* eslint-disable react/no-unescaped-entities */
import { useMemo, useState } from "react";

import Image from "next/image";

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import { images } from "./images";

import Hotels from "@/public/svg/itinerary/icons/hotel.svg";
import Meals from "@/public/svg/itinerary/icons/meals.svg";
import Sightseeings from "@/public/svg/itinerary/icons/sightseeing.svg";
import Flights from "@/public/svg/itinerary/icons/flight.svg";
import Transport from "@/public/svg/itinerary/icons/tranport.svg";

import Visa from "@/public/svg/itinerary/icons/visa.svg";

import Button from "@/components/button/Button";
import Tag from "@/components/tag/Tag";
import Heading from "../heading/heading";
import ImageLayout from "./ImageLayout";

export default function App() {
    const Overview = [
        {
            name: "Flights",
            icon: Flights,
        },
        {
            name: "Hotels",
            icon: Hotels,
        },
        {
            name: "All 3 Meals",
            icon: Meals,
        },
        {
            name: "Sightseeing",
            icon: Sightseeings,
        },


        {
            name: "Transport",
            icon: Transport,
        },
          
    ];
    const Tags = [
        {
            name: "36 Seats",
        },
        {
            name: "3 Cities",
        },
        {
            name: "Premium All Inclusive",
        },
    ];

    const [index, setIndex] = useState(-1);

    const currentImage = useMemo(() => images[index], [index]);
    const nextIndex = (index + 1) % images.length;
    const nextImage = images[nextIndex] || currentImage;
    const prevIndex = (index + images.length - 1) % images.length;
    const prevImage = images[prevIndex] || currentImage;

    const handleClick = (index: number) => setIndex(index);
    const handleClose = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);

    return (
        <div className="container mx-auto px-4 flex flex-col gap-6">
            
            <div className="gallery-title flex flex-wrap items-center justify-between gap-2">
                <Heading as="h2">Experience the Best of Sri Lanka - 5 Day Group Tour </Heading>
                
                {/* <Button
                    className="flex-center"
                    variant="orange"
                    onClick={() => handleClick(0)}
                >
                    <span>See More</span>
                </Button> */}
            </div>

            <ul className="tag-list flex flex-wrap items-center gap-3">
                {Tags.map((t, index) => {
                    return <Tag key={index} title={t.name} />;
                })}
            </ul>
            <ImageLayout images={images} handleClick={handleClick} />

            {index > -1 ? (
                <Lightbox
                    mainSrc={currentImage.original}
                    imageTitle={currentImage.caption}
                    mainSrcThumbnail={currentImage.src}
                    nextSrc={nextImage.original}
                    nextSrcThumbnail={nextImage.src}
                    prevSrc={prevImage.original}
                    prevSrcThumbnail={prevImage.src}
                    onCloseRequest={handleClose}
                    onMovePrevRequest={handleMovePrev}
                    onMoveNextRequest={handleMoveNext}
                />
            ) : null}
            <p className="font-light lead">
            Dive into Sri Lanka’s natural beauty and cultural gems on this thrilling 5-day group tour. From lush tea plantations and stunning beaches to ancient UNESCO World Heritage sites, every stop promises unforgettable experiences. Share new memories with fellow adventurers as you explore vibrant markets, savor local flavors, and embrace the warmth of island hospitality.
            </p>
            <ul className="overview-list flex items-center flex-wrap gap-6">
                {Overview.map((o, index) => {
                    return (
                        <li
                            className="overview-list-item flex items-center gap-2"
                            key={index}
                        >
                            <figure className="shrink-0">
                                <Image loading="lazy"
                                    src={o.icon}
                                    alt={o.name}
                                    width={44}
                                    height={44}
                                    
                                />
                            </figure>
                            <span className="font-medium">{o.name}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
